import { CircleCheck, CircleX } from "lucide-react";
import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

const CHIP_BY_STATUS = {
    VERIFIED: { label: "Verified", icon: CircleCheck, className: "bg-cm-p-container-green text-cm-p-on-container-green" },
    MISMATCH: { label: "Unverified", icon: CircleX, className: "bg-cm-p-container-red text-cm-p-on-container-red" },
    NOT_FOUND: { label: "Unverified", icon: CircleX, className: "bg-cm-p-container-red text-cm-p-on-container-red" },
    UNCHECKED: { label: "Pending verification", icon: null, className: "bg-cm-p-surface-container text-cm-p-text-secondary" },
};

export const CompanyVerificationChip = ({ status }) => {
    const chip = CHIP_BY_STATUS[status] ?? CHIP_BY_STATUS.UNCHECKED;
    const Icon = chip.icon;
    return (
        <div className={cn("inline-flex h-6 shrink-0 items-center justify-center gap-1 rounded-full px-2 text-xs font-medium uppercase", chip.className)}>
            {Icon && <Icon className="size-3" />}
            <TranslatedText>{chip.label}</TranslatedText>
        </div>
    );
};
